// import {ListViewProvider} from '../core/ListViewProvider'
// import {QueryRequestProvider} from '../core/QueryRequestProvider'
// import {QueryResponseProvider} from '../core/QueryResponseProvider'
// import {useFetchCommon} from '../../../../../../_metronic/helpers/crud-helper/useQuery'
// import {SankyWidget} from '../../../../../../_metronic/partials/widgets'
// import {useAuth} from '../../../../auth'
// import {useState} from 'react'
// import {KTCard} from '../../../../../../_metronic/helpers'

// const QualityList = () => {
//   const {currentUser, isSupplyChainManager, auth}: any = useAuth()
//   // console.log({currentUser, auths: auth?.data?.franchiseId, isSupplyChainManager})
//   const {responseData: sankey4} = useFetchCommon({
//     api: `sankey/franchise/multi/${
//       isSupplyChainManager ? auth?.data?.franchiseId : currentUser.id
//     }`,
//     isEnabled: true,
//     isDropDown: false,
//   })
//   const [showShankey, setShowShankey] = useState(false)
//   return (
//     <>
//       <div className='card-header border-0'>
//         <div className='card-toolbar'>
//           <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
//             <button
//               type='button'
//               style={{backgroundColor: '#12B886'}}
//               className='btn btn-primary mb-4'
//               onClick={() => setShowShankey(true)}
//               // onClick={openAddUserModal}
//             >
//               {/* <KTIcon iconName='plus' className='fs-2' /> */}
//               {/* {label} */}
//               Generate Sankey Diagram
//             </button>
//           </div>
//         </div>
//       </div>

//       {showShankey && (
//         <KTCard>
//           <div className='col-xl-8 p-4'>
//             {(sankey4.length > 1 && (
//               <SankyWidget label='Waste Flow Diagram' data={sankey4 || []} />
//             )) ||
//               ''}
//           </div>
//         </KTCard>
//       )}
//     </>
//   )
// }

// const WfdWrapper = () => (
//   <QueryRequestProvider initialValue={{enabled: false}}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <QualityList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )

// export {WfdWrapper}



import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import { SankyWidget, TablesWidget2 } from '../../../../../../_metronic/partials/widgets'
import { SWC } from '../../../../../../_metronic/partials/widgets/sankey/SWC'
import { TablesWidget2Copy } from '../../../../../../_metronic/partials/widgets/tables/TablesWidget2Copy'
import { TablesWidgetSku1 } from '../../../../../../_metronic/partials/widgets/tables/TablesWidgetSku1'
import { TablesWidgetSku2 } from '../../../../../../_metronic/partials/widgets/tables/TablesWidgetSku2'
import { useAuth } from '../../../../auth'
import { useState } from 'react'
import { KTCard, KTSVG } from '../../../../../../_metronic/helpers'
import { Modal } from 'react-bootstrap' // Make sure this import is correct for your project
import WfdItems from '../form-edit-modal/WfdItems'
import MapComponent from '../Map'
import { useEffect } from 'react'
import { FC, useRef } from 'react'
import DatePicker from 'react-datepicker'


const QualityList = () => {
  const { currentUser, isSupplyChainManager, auth }: any = useAuth()


  // const { responseData: sankey4 } = useFetchCommon({
  //   api: `sankey/franchise/multi/${isSupplyChainManager ? auth?.data?.franchiseId : currentUser.id
  //     }`,
  //   isEnabled: true,
  //   isDropDown: false,
  // })


  // const { responseData: sankey4, meta: sankeyMeta } = useFetchCommon({
  //   api: `sankey/franchise/multi/${isSupplyChainManager ? auth?.data?.franchiseId : currentUser.id}`,
  //   isEnabled: true,
  //   isDropDown: false,
  // });









  interface SankeyMeta {
    totalC2BQuantity: number;
    totalConvertQuantity: number;
    distinctCustomerCount: number;
    distinctConvertorCount: number;
    customerItemQuantities: Record<string, Record<string, number>>;
    convertorItemQuantities: Record<string, Record<string, number>>;
  }

  // Then use it:
  const [sankey4TRY, setSankey4TRY] = useState<SankeyMeta | null>(null);


  const [sankey4, setSankey4] = useState<any[] | null>(null);
  // const [sankey4TRY, setSankey4TRY] = useState<any[] | null>(null);
  // const [sankey4TRY, setSankey4TRY] = useState<any | null>(null);
  const [dataFetched, setDataFetched] = useState(false);

  // Move the fetch function outside useEffect
  // const fetchSankeyData = () => {
  //   const franchiseId = isSupplyChainManager ? auth?.data?.franchiseId : currentUser.id;

  //   fetch(`${process.env.REACT_APP_BASE_API_URL}sankey/franchise/multi/${franchiseId}`)
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then(responseData => {
  //       setSankey4(responseData.data || []);
  //       setSankey4TRY(responseData.meta || []);
  //       setDataFetched(true);
  //     })
  //     .catch(error => {
  //       console.error("Error fetching sankey data:", error);
  //     });
  // };



  const fetchSankeyData = () => {
    const franchiseId = isSupplyChainManager ? auth?.data?.franchiseId : currentUser.id;

    // Format dates to mm/dd/yyyy
    const formatDate = (date) => {
      if (!date) return '';
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear(); // Keep full year
      return `${month}/${day}/${year}`;
    };

    const startDateStr = formatDate(startDate);
    const endDateStr = formatDate(endDate);

    // Build query parameters
    let queryParams = '';
    if (startDateStr && endDateStr) {
      queryParams = `?start_date=${startDateStr}&end_date=${endDateStr}`;
    } else if (startDateStr) {
      queryParams = `?start_date=${startDateStr}`;
    } else if (endDateStr) {
      queryParams = `?end_date=${endDateStr}`;
    }

    fetch(`${process.env.REACT_APP_BASE_API_URL}sankey/franchise/multi/${franchiseId}${queryParams}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(responseData => {
        setSankey4(responseData.data || []);
        setSankey4TRY(responseData.meta || []);
        setDataFetched(true);
      })
      .catch(error => {
        console.error("Error fetching sankey data:", error);
      });
  };





  // Remove the useEffect that automatically calls fetchSankeyData
  const certificateRef = useRef<HTMLDivElement>(null)
  // const downloadCertificate = () => {
  //   if (!certificateRef.current) {
  //     alert('Certificate not found');
  //     return;
  //   }

  //   try {
  //     // Create a new print window
  //     const printWindow = window.open('', '_blank');
  //     if (!printWindow) {
  //       alert('Please allow pop-ups to download the certificate');
  //       return;
  //     }

  //     // Get all external stylesheets
  //     const styleSheets = Array.from(document.styleSheets);
  //     let styleContent = '';

  //     // Process each stylesheet
  //     styleSheets.forEach(sheet => {
  //       try {
  //         if (sheet.href) {
  //           // For external stylesheets, create a link
  //           const link = document.createElement('link');
  //           link.rel = 'stylesheet';
  //           link.href = sheet.href;
  //           printWindow.document.head.appendChild(link);
  //         } else {
  //           // For inline styles, extract rules
  //           const rules = Array.from(sheet.cssRules || []);
  //           rules.forEach(rule => {
  //             styleContent += rule.cssText + '\n';
  //           });
  //         }
  //       } catch (e) {
  //         console.log('Could not access stylesheet:', e);
  //       }
  //     });

  //     // Get the certificate HTML
  //     const certificateHTML = certificateRef.current.outerHTML;

  //     // Set the document content
  //     printWindow.document.write(`
  //     <!DOCTYPE html>
  //     <html>
  //       <head>
  //         <title>Certificate</title>
  //         <style>
  //           ${styleContent}
  //           @page {
  //             margin: 0;
  //           }
  //           html, body {
  //             margin: 0;
  //             padding: 0;
  //           }
  //           /* Define page breaks for sections */
  //           .page-section {
  //             page-break-before: always;
  //             break-before: page;
  //           }
  //           /* Avoid breaking images across pages */
  //           img, table {
  //             page-break-inside: avoid !important;
  //             break-inside: avoid !important;
  //           }
  //           .no-break {
  //             page-break-inside: avoid !important;
  //             break-inside: avoid !important;
  //           }
  //         </style>
  //       </head>
  //       <body style="margin: 0; padding: 0;">
  //         <div id="modified-certificate">
  //           ${certificateHTML}
  //         </div>
  //         <script>
  //           window.onload = function() {
  //             const certificate = document.getElementById('modified-certificate');
  //             if (!certificate) return;

  //             // Add page breaks programmatically
  //             const sections = certificate.querySelectorAll('.page-section');
  //             sections.forEach(section => {
  //               // Ensure a page break occurs after every section
  //               const pageBreak = document.createElement('div');
  //               pageBreak.className = 'page-break';
  //               section.after(pageBreak);
  //             });

  //             // Ensure images and tables inside sections don't break
  //             const images = certificate.querySelectorAll('img');
  //             const tables = certificate.querySelectorAll('table');
  //             [...images, ...tables].forEach(element => {
  //               const parent = element.parentNode;
  //               const wrapper = document.createElement('div');
  //               wrapper.classList.add('no-break');
  //               parent.insertBefore(wrapper, element);
  //               wrapper.appendChild(element);
  //             });

  //             // After content is fully loaded, print
  //             window.print();
  //             window.onfocus = function() {
  //               setTimeout(function() { window.close(); }, 500);
  //             };
  //           };
  //         </script>
  //       </body>
  //     </html>
  //   `);

  //     // Close the document to finalize the setup in the new window
  //     printWindow.document.close();

  //   } catch (error) {
  //     console.error('Error generating certificate:', error);
  //     alert('Failed to generate certificate. Please try again.');
  //   }
  // };


  const [showModal1, setShowModal1] = useState(false);
  const [modalData, setModalData] = useState(null);



  const getAuthToken = () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v');
      if (authData) {
        const parsedData = JSON.parse(authData);
        return parsedData.data?.token || null;
      }
      return null;
    } catch (error) {
      console.error('Error parsing auth data from localStorage:', error);
      return null;
    }
  };
  const handleIdClick = async (id) => {
    try {
      const token = getAuthToken();

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}collect/orders/${id}`, {
        headers: {
          'Authorization': token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      setModalData(data);
      setShowModal1(true);
    } catch (error) {
      console.error('Error fetching order details:', error);
    }
  };


  const downloadCertificate = () => {
    // Hide unwanted elements before printing
    const elementsToHide = document.querySelectorAll('.card-header, .btn, button, .card-toolbar');
    const originalStyles: string[] = [];

    // Store original display styles and hide elements
    elementsToHide.forEach((element, index) => {
      const htmlElement = element as HTMLElement;
      originalStyles[index] = htmlElement.style.display;
      htmlElement.style.display = 'none';
    });

    // Trigger the browser's print dialog (Ctrl+P)
    window.print();

    // Restore original styles after a short delay
    setTimeout(() => {
      elementsToHide.forEach((element, index) => {
        const htmlElement = element as HTMLElement;
        htmlElement.style.display = originalStyles[index];
      });
    }, 500);
  };

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);



  const [showShankey, setShowShankey] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [isUserLoading, setIsUserLoading] = useState(false)
  const [sankeyData, setSankeyData] = useState<any>(null);


  const [showMapModal, setShowMapModal] = useState(false);
  const [mapData, setMapData] = useState<any[]>([]);

  // Function to handle data received from WfdItems
  const handleDataReceived = (data: any) => {
    setSankeyData(data || [])
    setShowShankey(true)
  }

  // Function to open the modal
  const handleSelectItems = () => {
    setIsUserLoading(true)
    setTimeout(() => {
      setIsUserLoading(false)
      setShowModal(true)
    }, 500)
  }

  // Function to close the modal
  const handleCloseModal = () => {
    setShowModal(false)
  }



  console.log("sankeyData", sankeyData?.meta?.totalC2BQuantity)

  return (
    <>
      <div className='card-header border-0'>
        <div className='card-toolbar'>
          {/* <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'> */}


          <div className="card mb-3">
            <div className="card-body">
              <div className='d-flex justify-content-between' data-kt-user-table-toolbar='base'>
                <div className="d-flex gap-4">
                  <div>
                    <label className="form-label fs-6 fw-bold mb-2">Start date</label>
                    <DatePicker
                      customInput={
                        <input
                          style={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #dddddd',
                            color: '#000000',
                          }}
                        />
                      }
                      placeholderText="Select start date"
                      className="form-control form-control-solid"
                      style={{
                        width: '200px',
                        backgroundColor: '#f9f9f9'
                      }}
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                    />
                  </div>
                  <div>
                    <label className="form-label fs-6 fw-bold mb-2">End date</label>
                    <DatePicker
                      customInput={
                        <input
                          style={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #dddddd',
                            color: '#000000',
                          }}
                        />
                      }
                      placeholderText="Select end date"
                      className="form-control form-control-solid"
                      style={{
                        width: '200px',
                        backgroundColor: '#f9f9f9'
                      }}
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </div>
                </div>
                <div className="d-flex">
                  <button
                    style={{ backgroundColor: 'black', color: "white" }}
                    className='btn btn-light-primary me-3 mb-4'
                    type='button'
                    onClick={downloadCertificate}
                  // className='btn btn-primary'
                  >
                    Download
                  </button>
                  <button
                    type='button'
                    style={{ color: "white" }}
                    className='btn btn-light-primary me-3 mb-4'
                    onClick={handleSelectItems}
                    disabled={isUserLoading}
                  >
                    {isUserLoading ? (
                      <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                    ) : (
                      ''
                    )}
                    {' SKU Wise'}
                  </button>

                  {/* Generate Sankey Diagram Button */}
                  {/* <button
              type='button'
              style={{ backgroundColor: '#12B886' }}
              className='btn btn-primary mb-4'
              onClick={() => setShowShankey(true)}
            >
              All Materials
            </button> */}
                  <button
                    type='button'
                    // style={{ backgroundColor: '#ED6E43' }}
                    className='btn btn-primary mb-4'
                    onClick={() => {
                      if (!dataFetched) {
                        fetchSankeyData();
                      }
                      setShowShankey(true);
                    }}
                  >
                    All Materials
                  </button>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>

      {/* Sankey Diagram */}






      <div ref={certificateRef}>
        {sankeyData ? (
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#dff5eb',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Material inflow</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {/* {sankeyData?.meta?.totalC2BQuantity} */}
                    {sankeyData?.meta?.totalC2BQuantity ? Number(sankeyData.meta.totalC2BQuantity).toFixed(2) : '0.00'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start', // ✅ center horizontally
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',        // ✅ center vertically inside this row
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#c8f0e8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src="/media/svg/dashboard/New/recycling factory.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Material outflow</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {/* {sankeyData?.meta?.totalConvertQuantity} */}
                    {sankeyData?.meta?.totalConvertQuantity ? Number(sankeyData.meta.totalConvertQuantity).toFixed(2) : '0.00'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start', // ✅ center horizontally
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',        // ✅ center vertically inside this row
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#f7f5c5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>

                  <img src="/media/svg/dashboard/New/waste supplier.png" alt="" style={{ width: '27px', height: '27px' }}></img>

                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Unique Household</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {sankeyData?.meta?.distinctCustomerCount}
                  </div>
                </div>
              </div>
            </div>


            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start', // ✅ center horizontally
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',        // ✅ center vertically inside this row
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#e4d9f2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src="/media/svg/dashboard/New/Facilities.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Unique Customers</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {sankeyData?.meta?.distinctConvertorCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {sankey4TRY ? (
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#dff5eb',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Material inflow</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {/* {sankey4TRY?.totalC2BQuantity} */}
                    {sankey4TRY?.totalC2BQuantity ? Number(sankey4TRY.totalC2BQuantity).toFixed(2) : '0.00'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start', // ✅ center horizontally
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',        // ✅ center vertically inside this row
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#c8f0e8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src="/media/svg/dashboard/New/recycling factory.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Material outflow</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {/* {sankey4TRY?.totalConvertQuantity} */}
                    {sankey4TRY?.totalConvertQuantity ? Number(sankey4TRY.totalConvertQuantity).toFixed(2) : '0.00'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start', // ✅ center horizontally
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',        // ✅ center vertically inside this row
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#f7f5c5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>

                  <img src="/media/svg/dashboard/New/waste supplier.png" alt="" style={{ width: '27px', height: '27px' }}></img>

                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Unique Household</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {sankey4TRY?.distinctCustomerCount}
                  </div>
                </div>
              </div>
            </div>


            <div style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start', // ✅ center horizontally
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',        // ✅ center vertically inside this row
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#e4d9f2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src="/media/svg/dashboard/New/Facilities.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>Unique Customers</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {sankey4TRY?.distinctConvertorCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {showShankey && (
          <KTCard>
            <div className='col-xl-7 p-4'>
              {(() => {
                // console.log("sankeyData:", sankeyData);
                // console.log("sankey4:", sankey4);

                // Check if sankeyData exists and has the expected structure
                if (sankeyData && sankeyData.data && Array.isArray(sankeyData.data) && sankeyData.data.length > 0) {
                  return (
                    <SWC
                      label='Material Tracebility Map'
                      data={sankeyData.data[0]}
                    />
                  );
                }
                // Otherwise use sankey4 if it exists
                else if (sankey4 && Array.isArray(sankey4) && sankey4.length > 1) {
                  return (
                    <SWC
                      label='Material Tracebility Map'
                      data={sankey4[0]}
                    />
                  );
                }

                return ''; // Return empty if no data is available
              })()}
            </div>
          </KTCard>
        )}
        <div className='row g-5 g-xl-8 mt-5'>
          <div className='col-xl-6'>
            <TablesWidgetSku1
              linkTo='/apps/transactions/collect-orders'
              className='card-xl-stretch mb-5 mb-xl-8'
              // cleanUpData={sankey4TRY}
              cleanUpData={sankeyData?.meta || sankey4TRY}
            />
          </div>
          <div className='col-xl-6'>
            <TablesWidgetSku2
              linkTo='/apps/transactions/items'
              className='card-xl-stretch mb-5 mb-xl-8'
              // dispatchData={sankey4TRY}
              dispatchData={sankeyData?.meta || sankey4TRY}
            />
          </div>
        </div>

        <h3 style={{ marginLeft: "10px" }}>Provenance matrix</h3>

        {showShankey && (
          <KTCard className="mt-4">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover table-rounded table-striped border gy-7 gs-7">
                  <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                      <th style={{ width: '120px' }}>Date</th>
                      {/* <th>Batch id</th> */}
                      <th>Transaction</th>
                      <th>Category</th>
                      <th>Item</th>
                      <th>Source</th>
                      <th>Destination</th>
                      <th>Location</th>
                      <th>Images</th>
                      <th>Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      // Use the same data selection logic as for the Sankey diagram
                      const tableData =
                        (sankeyData && sankeyData.data && Array.isArray(sankeyData.data) && sankeyData.data.length > 0)
                          ? sankeyData.data[1]
                          : (sankey4 && Array.isArray(sankey4) && sankey4.length > 1)
                            ? sankey4[1]
                            : [];

                      return tableData.map((item, index) => (
                        <tr key={index}>
                          {/* <td> {item.actualCollectionDate ?
                            new Date(item.actualCollectionDate).toISOString().split('T')[0] :
                            '-'}</td>
                          <td>{item.id || '-'}</td> */}
                          <td>
                            <div>
                              {item.transactionDate ?
                                new Date(item.transactionDate).toISOString().split('T')[0] :
                                '-'}
                            </div>
                            <div style={{
                              marginTop: '4px',
                              padding: '2px 1px',
                              backgroundColor: '#f5f5f5',
                              borderRadius: '4px',
                              fontSize: '0.85em',
                              color: '#6c757d',
                              cursor: (item.transactionType === 'C2B' || item.transactionType === 'B2B') ? 'pointer' : 'default'
                            }}
                              onClick={() => {
                                if (item.transactionType === 'C2B' || item.transactionType === 'B2B') {
                                  handleIdClick(item.id);
                                }
                              }}
                            >
                              {item.id || '-'}
                            </div>
                          </td>
                          <td>
                            <span style={{
                              backgroundColor: '#f8f5ff',
                              color: '#7239ea',
                              padding: '4px 8px',
                              borderRadius: '6px',
                              fontSize: '12px',
                              // fontWeight: '500',
                              display: 'inline-block',
                              fontWeight: "bold"
                            }}>
                              {item.transactionType ?
                                (item.transactionType === 'C2B' ? 'First Collection' :
                                  item.transactionType === 'B2B' ? 'Material Transfer' :
                                    item.transactionType === 'CONVERT' ? 'Final Dispatch' :
                                      item.transactionType) :
                                '-'}
                            </span>
                          </td>
                          <td>{item.categoryName || '-'}</td>
                          {/* <td>{item.itemName || '-'}</td> */}
                          <td>
                            {(item.itemName && item.itemName.length > 20)
                              ? `${item.itemName.substring(0, 20)}...`
                              : (item.itemName || '-')
                            }
                          </td>
                          {/* <td>{(item.customerName && item.customerName.length > 15) ?
                            `${item.customerName.substring(0, 15)}...` :
                            (item.customerName || '-')}
                          </td> */}
                          <td>
                            {(item.transactionType === "CONVERT" || item.transactionType === "B2B")
                              ? (item.fromPickUppointName && item.fromPickUppointName.length > 15)
                                ? `${item.fromPickUppointName.substring(0, 15)}...`
                                : (item.fromPickUppointName || '-')
                              : (item.customerName && item.customerName.length > 15)
                                ? `${item.customerName.substring(0, 15)}...`
                                : (item.customerName || '-')
                            }
                          </td>
                          <td>{(item.toPickUppointName && item.toPickUppointName.length > 15) ?
                            `${item.toPickUppointName.substring(0, 15)}...` :
                            (item.toPickUppointName || '-')}
                          </td>
                          <td>
                            {item.location ? (
                              <span
                                className="text-primary cursor-pointer text-decoration-underline"
                                onClick={() => {
                                  try {
                                    // Parse location string
                                    const [latStr, lngStr] = item.location.split(',');
                                    const lat = parseFloat(latStr);
                                    const lng = parseFloat(lngStr);

                                    if (!isNaN(lat) && !isNaN(lng)) {
                                      // Format data as expected by MapComponent
                                      const locationData = [{
                                        name: item.itemName || 'Item Location', // Use item name or default
                                        position: {
                                          lat: lat,
                                          lng: lng
                                        }
                                      }];

                                      setMapData(locationData);
                                      setShowMapModal(true);
                                    } else {
                                      alert("Invalid location format");
                                    }
                                  } catch (e) {
                                    console.error("Error parsing location:", e);
                                    alert("Could not parse location data");
                                  }
                                }}
                              >
                                Click to view
                              </span>
                            ) : '-'}
                          </td>

                          {/* <td>
                            {item.images[0] ? (
                              <img
                                src={item.images[0]}
                                alt="Item image"
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  objectFit: 'cover',
                                  borderRadius: '50%'
                                }}
                                onClick={() => window.open(item.images[0], '_blank')}
                                className="cursor-pointer"
                              />
                            ) : '-'}
                          </td> */}
                          <td>
                            {item.images && item.images.length > 0 ? (
                              <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                {item.images.slice(0, 3).map((image, index) => (
                                  <img
                                    key={index}
                                    src={image}
                                    alt={`Item image ${index + 1}`}
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      objectFit: 'cover',
                                      borderRadius: '50%'
                                    }}
                                    onClick={() => window.open(image, '_blank')}
                                    className="cursor-pointer"
                                  />
                                ))}
                              </div>
                            ) : '-'}
                          </td>
                          <td>{item.qty || '-'}</td>
                        </tr>
                      ));
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
          </KTCard>
        )}
      </div>

      <Modal
        show={showMapModal}
        onHide={() => setShowMapModal(false)}
        size="lg"
        aria-labelledby="map-modal-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="map-modal-title">Location Map</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MapComponent
            zooms={14}
            data={mapData}
          />
        </Modal.Body>
      </Modal>




      {/* Modal for WfdItems component */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WfdItems
            isUserLoading={isUserLoading}
            onDataReceived={handleDataReceived}
            onClose={handleCloseModal}

            startDate={startDate}
            endDate={endDate}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

const WfdWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { WfdWrapper }






